import React, { useRef } from 'react';
import { connect } from 'react-redux';
import Loadable from '@loadable/component';
import LoadingIndicator from 'Components/loading/LoadingBars';
const LoadableMain = Loadable(() => import('Containers/Main'), {
  fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
});
const mapState = ({
  nav: {
    location
  },
  user
}) => {
  return {
    path: location,
    user: user
  };
};
const connector = connect(mapState);
const App = () => {
  // this ref is anticipating a world where we want to use the header/banner logic from lv-web
  const headerRef = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "header-container",
    ref: headerRef
  }), /*#__PURE__*/React.createElement(LoadableMain, null));
};
export default connector(App);